export const API_ERROR_CODES = {
  INVALID_EMAIL: '4503',
  SUBSCRIPTION_PROVIDER_STATE_CONFLICT: 'SUBSCRIPTION_PROVIDER_STATE_CONFLICT',
} as const

export type ApiErrorCode = (typeof API_ERROR_CODES)[keyof typeof API_ERROR_CODES]
